type AsyncExecuteSuccess<Result> = [null, Result];
type AsyncExecuteFailure<Error> = [Error, null];

/**
 *
 * @param promise
 * @param errorTransformFn for catching the rejection and transforming the error.
 *
 * @returns [error | null, result | null] error is the rejection from the promise, result is the resolved from the promise
 */
export async function asyncExecute<T, K extends Error> (
    // A promise
    promise: Promise<T>,
    errorTransformFn?: (error: Error) => K,
): Promise<AsyncExecuteSuccess<T> | AsyncExecuteFailure<K>> {
    let result: T | null = null;

    try {
        result = await promise;
        return [null, result];
    } catch (e) {
        if (errorTransformFn) {
            const caughtError = e instanceof Error ? e : new Error(String(e));
            const transformedError = errorTransformFn(caughtError) as K;
            return [transformedError, null];
        }
        const errorValue = e instanceof Error ? e : new Error(String(e));
        return [errorValue as unknown as K, null];
    }
}
